const markets = [
  //  na: [
  {
    country: 'United States of America',
    id: 'ATVPDKIKX0DER',
    region: 'na',
    code: 'US',
    url: 'https://sellercentral.amazon.com',
  },
  { country: 'Canada', id: 'A2EUQ1WTGCTBG2', region: 'na', code: 'CA', url: 'https://sellercentral.amazon.ca' },
  { country: 'Mexico', id: 'A1AM78C64UM0Y8', region: 'na', code: 'MX', url: 'https://sellercentral.amazon.com.mx' },
  { country: 'Brazil', id: 'A2Q3Y263D00KWC', region: 'na', code: 'BR', url: 'https://sellercentral.amazon.com.br' },
  //  ],
  // eu: [
  {
    country: 'Spain',
    id: 'A1RKKUPIHCS9HS',
    region: 'eu',
    code: 'ES',
    url: 'https://sellercentral-europe.amazon.com',
  },
  {
    country: 'United Kingdom',
    id: 'A1F83G8C2ARO7P',
    region: 'eu',
    code: 'GB',
    url: 'https://sellercentral-europe.amazon.com',
  },
  {
    country: 'France',
    id: 'A13V1IB3VIYZZH',
    region: 'eu',
    code: 'FR',
    url: 'https://sellercentral-europe.amazon.com',
  },
  { country: 'Netherlands', id: 'A1805IZSGTT6HS', region: 'eu', code: 'NL', url: 'https://sellercentral.amazon.nl' },
  {
    country: 'Germany',
    id: 'A1PA6795UKMFR9',
    region: 'eu',
    code: 'DE',
    url: 'https://sellercentral-europe.amazon.com',
  },
  { country: 'Italy', id: 'APJ6JRA9NG5V4', region: 'eu', code: 'IT', url: 'https://sellercentral-europe.amazon.com' },
  { country: 'Sweden', id: 'A2NODRKZP88ZB9', region: 'eu', code: 'SE', url: 'https://sellercentral.amazon.se' },
  { country: 'Poland', id: 'A1C3SOZRARQ6R3', region: 'eu', code: 'PL', url: 'https://sellercentral.amazon.pl' },
  { country: 'Egypt', id: 'ARBP9OOSHTCHU', region: 'eu', code: 'EG', url: 'https://sellercentral.amazon.eg' },
  { country: 'Turkey', id: 'A33AVAJ2PDY3EV', region: 'eu', code: 'TR', url: 'https://sellercentral.amazon.com.tr' },
  {
    country: 'Saudi Arabia',
    id: 'A17E79C6D8DWNP',
    region: 'eu',
    code: 'SA',
    url: 'https://sellercentral.amazon.com.sa',
  },
  {
    country: 'United Arab Emirates',
    id: 'A2VIGQ35RCS4UG',
    region: 'eu',
    code: 'AE',
    url: 'https://sellercentral.amazon.ae',
  },
  { country: 'India', id: 'A21TJRUUN4KGV', region: 'eu', code: 'IN', url: 'https://sellercentral.amazon.in' },
  // ],
  // fe: [
  { country: 'Singapore', id: 'A19VAU5U5O7RUS', region: 'fe', code: 'SG', url: 'https://sellercentral.amazon.sg' },
  {
    country: 'Australia',
    id: 'A39IBJ37TRP1C6',
    region: 'fe',
    code: 'AU',
    url: 'https://sellercentral.amazon.com.au',
  },
  { country: 'Japan', id: 'A1VC38T7YXB528', region: 'fe', code: 'JP', url: 'https://sellercentral.amazon.co.jp' },
  //],
];

export default markets;
